import Vue from "vue";
import VueRouter from "vue-router";
import login from "./modules/security";
import home from "./modules/home";
import subscription from "./modules/subscription";
import training from "./modules/training";
import account from "./modules/account";
import studentProgramme from "./modules/student-programme";
import homework from "./modules/homework";
import library from "./modules/library";
import adventure from "./modules/adventure";

import { getToken, getUserInfo, setUserInfo } from "@/utils/auth";
import store from "@/store";

Vue.use(VueRouter);

export const routes = [
  {
    path: "/",
    // redirect: "/home",
    component: () => import("@/layout/index"),
    children: [...home, ...subscription],
  },
  // {
  //   path: "/demo",
  //   // redirect: "/home",
  //   component: () => import("@/demo.vue"),
  // },
  ...training,
  {
    path: "/studentProgramme",
    redirect: "adventure",
    component: () => import("@/views/student-programme"),
    children: [...studentProgramme, ...adventure, ...homework, ...library],
  },
  // { name:'libraryTest', path: '/libraryTest', component: () => import('@/views/library-mode/test') },
  ...account,
  ...login,
  { path: "*", component: () => import("@/views/404") },
];

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

router.beforeEach(async (to, from, next) => {
  if (
    getToken() &&
    getUserInfo("userInfo") &&
    getUserInfo("userInfo").roleName &&
    getUserInfo("userProfile")
  ) {
    let userInfo = getUserInfo("userInfo");
    let userProfile = getUserInfo("userProfile");
    let roles = userInfo.roleName;
    if (
      to.path === "/" ||
      to.path === "/login" ||
      to.path === "/register" ||
      to.path === "/forget-password"
    ) {
      if (roles == "parent") {
        if (userProfile.students.length > 0) {
          let list = userProfile.students.filter((item) => {
            return item.subscriptions.length > 0;
          });
          if (list.length > 0) next({ path: "/account" });
          else
            next({
              name: "subscribe",
              query: {
                id: userProfile.id,
                isRenew: true,
                needSubscribe: true,
              },
            });
        } else
          next({
            name: "subscribe",
            query: { id: userProfile.id, needSubscribe: true },
          });
      } else if (roles == "student") {
          let detail = JSON.parse(JSON.stringify(userProfile));
        // let now = new Date().getTime();
        // detail.subscriptionIndex = detail.subscriptions.findIndex((item) => {
        //   return (
        //     new Date(item.startDate).getTime() < now &&
        //     new Date(item.endDate).getTime() > now
        //   );
        // });
        detail.subscriptionIndex=0
        setUserInfo("userProfile", detail);
        store.dispatch(
          "setGradeId",
          detail.subscriptions[detail.subscriptionIndex].gradeId
        );
        next({ path: "/studentProgramme" });
      }
    } else if (to.path === "/*") {
      next();
    } else if (
      (to.path === "/subscribe" ||
        to.path === "/checkout" ||
        to.path === "/payment") &&
      roles == "student"
    ) {
      next({ path: "*" });
    }
    // else if(to.path === "/selectSubscribed"){
    //   let detail = JSON.parse(JSON.stringify(userProfile));
    //   if (detail.id === 222 ||detail.id === 223) {
    //     next();
    //   } else {
    //     next({ path: "/studentProgramme" }); // 阻止访问（或跳转到无权限页面）
    //   }
    // }
    else {
      if (
        (to.meta.roles &&
          to.meta.roles.some((role) => roles.indexOf(role) >= 0)) ||
        !to.meta.roles
      )
        next();
      else next({ path: "*" }); //router.push('/*')
    }
  } else {
    if(to.path === "/examinationAnswerResult") next();
    else if (to.meta.roles) next({ path: "/login" });
    else if (to.path === "/") next({ path: "/home" });
    else next(); //router.push('/*')
  }
});

export default router;
